import classNames from 'classnames'
import type {ReactElement, HTMLAttributes} from 'react'

import styles from './Contents.css'

function Contents({
  children,
  className,
  ...restProps
}: HTMLAttributes<HTMLDivElement>): ReactElement {
  const classes = classNames(styles.contents, className)

  return (
    <div {...restProps} className={classes}>
      {children}
    </div>
  )
}

export default Contents
